import { Route } from 'react-router-dom';

import Dashboard from '@legacy-components/admin/Dashboard';
import StatisticsDashboard from '@legacy-components/admin/StatisticsDashboard';
import CompaniesCreate from '@legacy-components/admin/companies/Create';
import CompaniesEdit from '@legacy-components/admin/companies/Edit';
import CompaniesList from '@legacy-components/admin/companies/List';
import EmployeesCreate from '@legacy-components/admin/employees/Create';
import EmployeesEdit from '@legacy-components/admin/employees/Edit';
import EmployeesList from '@legacy-components/admin/employees/List';
import EventsDetail from '@legacy-components/admin/events/Detail';
import EventsList from '@legacy-components/admin/events/List';
import FrequentPassageStickerHandout from '@legacy-components/admin/frequentPassages/FrequentPassageStickerHandout';
import GatesList from '@legacy-components/admin/gates/List';
import LocationsList from '@legacy-components/admin/locations/List';
import MaterialCategoriesList from '@legacy-components/admin/materials/materialCategories/List';
import MaterialRequestsList from '@legacy-components/admin/materials/materialRequests/List';
import MaterialsList from '@legacy-components/admin/materials/materials/List';
import RentalList from '@legacy-components/admin/materials/rentals/List';
import ParkingStickers from '@legacy-components/admin/parkingStickers/List';
import ParkingStickersScan from '@legacy-components/admin/parkingStickers/ParkingStickersScan';
import ParkingStickersVouchers from '@legacy-components/admin/parkingStickers/ParkingStickersVouchers';
import PeriodsList from '@legacy-components/admin/periods/List';
import RegistrationsCreate from '@legacy-components/admin/registrations/Create';
import RegistrationsEdit from '@legacy-components/admin/registrations/Edit';
import RegistrationsImport from '@legacy-components/admin/registrations/Import';
import SafetyQuestionAnswersReview from '@legacy-components/admin/registrations/pages/SafetyQuestionAnswersReview';
import Activity from '@legacy-components/admin/reporting/activity/List';
import CateringClaimsOverview from '@legacy-components/admin/reporting/cateringClaims/List';
import Exports from '@legacy-components/admin/reporting/exports/Exports';
import Invoices from '@legacy-components/admin/reporting/invoices/Invoices';
import DepartmentsList from '@legacy-components/admin/settings/departments/List';
import EmailsList from '@legacy-components/admin/settings/emails/List';
import OccupationsList from '@legacy-components/admin/settings/occupations/List';
import ProfileGroupsList from '@legacy-components/admin/settings/profileGroups/List';
import ProfilesList from '@legacy-components/admin/settings/profiles/List';
import Devices from '@legacy-components/admin/system/Devices';
import Queue from '@legacy-components/admin/system/Queue';
import Tokens from '@legacy-components/admin/system/Tokens';
import TransportRequestsList from '@legacy-components/admin/transportRequests/List';
import GroupsCreate from '@legacy-components/admin/userManagement/groups/Create';
import GroupsEdit from '@legacy-components/admin/userManagement/groups/Edit';
import GroupsList from '@legacy-components/admin/userManagement/groups/List';
import UsersCreate from '@legacy-components/admin/userManagement/users/Create';
import UsersEdit from '@legacy-components/admin/userManagement/users/Edit';
import UsersList from '@legacy-components/admin/userManagement/users/List';
import VenuesList from '@legacy-components/admin/venues/venues/List';
import ZonesCreate from '@legacy-components/admin/venues/zones/Create';
import ZonesEdit from '@legacy-components/admin/venues/zones/Edit';
import ZonesList from '@legacy-components/admin/venues/zones/List';
import BoxOffice from '@legacy-components/admin/wristbands/boxoffice/BoxOffice';
import BoxOfficeCrewMaterials from '@legacy-components/admin/wristbands/boxoffice/BoxOfficeCrewMaterials';
import PrintersOverview from '@legacy-components/admin/wristbands/printers/List';
import WristbandsOverview from '@legacy-components/admin/wristbands/wristbands/List';
import Tracker from '@legacy-components/admin/wristbands/wristbands/Tracker';

import ListCertificates from '@admin/certificates/views/ListCertificates/ListCertificates';
import { CreateFrequentPassageRequest } from '@admin/frequent-passage-requests/views/CreateFrequentPassageRequest';
import { ListFrequentPassageRequests } from '@admin/frequent-passage-requests/views/ListFrequentPassageRequests';
import { EditWristbandTemplate } from '@admin/periods/views/EditWristbandTemplate';
import { RegistrationsList } from '@admin/registrations/views/RegistrationsList';
import { CreateTimeTrackingGroup } from '@admin/time-tracking-groups/views/CreateTimeTrackingGroup';
import { EditTimeTrackingGroup } from '@admin/time-tracking-groups/views/EditTimeTrackingGroup';
import { ListTimeTrackingGroups } from '@admin/time-tracking-groups/views/ListTimeTrackingGroups';
import { ListTimeTrackingEntries } from '@admin/time-tracking/views/ListTimeTrackingEntries';
import { TransportScansList } from '@admin/transport-scans/views/TransportScansList';
import { ShowUser } from '@admin/users/views/ShowUser';
import { CreateVenue as NewVenuesCreate } from '@admin/venues/views/CreateVenue';
import { EditVenue as NewVenuesEdit } from '@admin/venues/views/EditVenue';
import { ListVenues as NewVenuesList } from '@admin/venues/views/ListVenues';

export function AdminRoutes() {
  return (
    <>
      <Route exact path="/admin" component={Dashboard} />
      <Route exact path="/admin/dashboard" component={StatisticsDashboard} />

      <Route exact path="/admin/users" component={UsersList} />
      <Route exact path="/admin/users/create" component={UsersCreate} />
      <Route path="/admin/users/:id/registrations" component={ShowUser} />
      <Route exact path="/admin/users/:id/edit" component={UsersEdit} />

      <Route exact path="/admin/groups" component={GroupsList} />
      <Route exact path="/admin/groups/create" component={GroupsCreate} />
      <Route exact path="/admin/groups/:id/edit" component={GroupsEdit} />

      <Route exact path="/admin/venues" component={VenuesList} />
      <Route exact path="/admin/venues/:id/edit" component={VenuesList} />

      <Route exact path="/admin/new-venues" component={NewVenuesList} />
      <Route exact path="/admin/new-venues/create" component={NewVenuesCreate} />
      <Route exact path="/admin/new-venues/:id/edit" component={NewVenuesEdit} />

      <Route exact path="/admin/zones" component={ZonesList} />
      <Route exact path="/admin/zones/create" component={ZonesCreate} />
      <Route exact path="/admin/zones/:id/edit" component={ZonesEdit} />

      <Route exact path="/admin/events" component={EventsList} />
      <Route exact path="/admin/events/:id/edit" component={EventsList} />
      <Route path="/admin/events/:id" component={EventsDetail} />

      <Route exact path="/admin/periods" component={PeriodsList} />
      <Route exact path="/admin/periods/:id/wristband" component={EditWristbandTemplate} />

      <Route exact path="/admin/companies" component={CompaniesList} />
      <Route exact path="/admin/companies/create" component={CompaniesCreate} />
      <Route exact path="/admin/companies/:id/edit" component={CompaniesEdit} />

      <Route exact path="/admin/employees" component={EmployeesList} />
      <Route exact path="/admin/employees/create" component={EmployeesCreate} />
      <Route exact path="/admin/employees/:id/edit" component={EmployeesEdit} />

      <Route exact path="/admin/profile-groups" component={ProfileGroupsList} />
      <Route exact path="/admin/profile-groups/:id/edit" component={ProfileGroupsList} />

      <Route exact path="/admin/profiles" component={ProfilesList} />
      <Route exact path="/admin/profiles/:id/edit" component={ProfilesList} />

      <Route exact path="/admin/functions" component={OccupationsList} />
      <Route exact path="/admin/functions/:id/edit" component={OccupationsList} />

      <Route exact path="/admin/departments" component={DepartmentsList} />
      <Route exact path="/admin/departments/:id/edit" component={DepartmentsList} />

      <Route exact path="/admin/material-categories" component={MaterialCategoriesList} />
      <Route exact path="/admin/material-categories/:id/edit" component={MaterialCategoriesList} />

      <Route exact path="/admin/materials" component={MaterialsList} />
      <Route exact path="/admin/materials/:id/edit" component={MaterialsList} />

      <Route exact path="/admin/certificates" component={ListCertificates} />

      <Route exact path="/admin/registrations" component={RegistrationsList} />
      <Route exact path="/admin/registrations/create" component={RegistrationsCreate} />
      <Route path="/admin/registrations/:id/edit" component={RegistrationsEdit} />
      <Route exact path="/admin/registrations/import" component={RegistrationsImport} />

      <Route exact path="/admin/gates" component={GatesList} />
      <Route exact path="/admin/gates/:id/edit" component={GatesList} />

      <Route exact path="/admin/locations" component={LocationsList} />
      <Route exact path="/admin/locations/:id/edit" component={LocationsList} />

      <Route exact path="/admin/material-requests" component={MaterialRequestsList} />
      <Route exact path="/admin/rental" component={RentalList} />
      <Route exact path="/admin/transport-requests" component={TransportRequestsList} />
      <Route exact path="/admin/transport-scans" component={TransportScansList} />
      <Route exact path="/admin/frequent-passage-requests" component={ListFrequentPassageRequests} />
      <Route exact path="/admin/frequent-passage-requests/:id" component={CreateFrequentPassageRequest} />
      <Route path="/admin/frequent-passage-stickers" component={FrequentPassageStickerHandout} />
      <Route exact path="/admin/printers" component={PrintersOverview} />
      <Route path="/admin/front-desk" component={BoxOffice} />
      <Route path="/admin/parking-vouchers" component={ParkingStickersVouchers} />
      <Route exact path="/admin/parking-stickers" component={ParkingStickers} />
      <Route exact path="/admin/parking-stickers/scanner" component={ParkingStickersScan} />
      <Route exact path="/admin/crew-materials" component={BoxOfficeCrewMaterials} />
      <Route exact path="/admin/wristbands" component={WristbandsOverview} />
      <Route exact path="/admin/tracker/:id" component={Tracker} />
      <Route exact path="/admin/catering-claims" component={CateringClaimsOverview} />
      <Route exact path="/admin/safety-question-answers/review" component={SafetyQuestionAnswersReview} />

      <Route exact path="/admin/time-tracking-groups" component={ListTimeTrackingGroups} />
      <Route exact path="/admin/time-tracking-groups/create" component={CreateTimeTrackingGroup} />
      <Route exact path="/admin/time-tracking-groups/:id/edit" component={EditTimeTrackingGroup} />
      <Route exact path="/admin/time-tracking-groups/:id/show" component={ListTimeTrackingEntries} />

      <Route exact path="/admin/activity" component={Activity} />

      <Route exact path="/admin/queue" component={Queue} />
      <Route exact path="/admin/tokens" component={Tokens} />
      <Route exact path="/admin/devices" component={Devices} />
      <Route exact path="/admin/exports" component={Exports} />
      <Route exact path="/admin/invoices" component={Invoices} />
      <Route exact path="/admin/emails" component={EmailsList} />
      <Route exact path="/admin/emails/:emailTemplateId/edit" component={EmailsList} />
    </>
  );
}
